import React from "react";
import AnimateLine from "../../../common/AnimateLine";
import Breadcrumb from "../../../common/Breadcrumb";
import SubscribArea from "../../../common/SubscribArea";
import ProjectDetailsWrap11 from "../TSALaw/ProjectDetailsWrap11";

function ProjectDetails11() {
  return (
    <>
      <div className="ebrandy-wrap">
        <AnimateLine />
        <Breadcrumb pageName="TSA Law" pageTitle="TSA Law" />
        <ProjectDetailsWrap11 />
        <SubscribArea />
      </div>
    </>
  );
}

export default ProjectDetails11;
